// Mock API för lokal utveckling
export const mockLogin = async (code) => {
  // Simulera API-anrop
  await new Promise(resolve => setTimeout(resolve, 500));

  if (code === 'test') {
    return { success: true };
  } else {
    return { success: false, message: 'Fel kod. Försök igen!' };
  }
};

export const mockFamilies = [
  "Anna",
  "Axel",
  "Erica",
  "Kerstin",
  "Micaela",
  "Niclas",
  "Poppe",
  "Rebecca",
  "Stig",
  "Thomas",
  "Victoria"
];

// Använd localStorage för att hålla bokningar mellan sessioner
let storedBookings = [];
try {
  const stored = localStorage.getItem('mockBookings');
  if (stored) {
    storedBookings = JSON.parse(stored);
  }
} catch (error) {
  console.error('Kunde inte läsa bokningar från localStorage:', error);
}

// Viktig: Ta bort regelbunden rensning av localStorage!
// Använd storedBookings som källa istället för tom array
export const mockBookings = [...storedBookings];

// Funktion för att spara bokningar till localStorage
// Generate unique ID for mock data
const generateId = () => Math.random().toString(36).substr(2, 9).toUpperCase();

export const saveMockBookings = (bookings) => {
  try {
    localStorage.setItem('mockBookings', JSON.stringify(bookings));
    storedBookings.length = 0;
    storedBookings.push(...bookings);
  } catch (error) {
    console.error('Kunde inte spara bokningar till localStorage:', error);
  }
};

// Mock function for updating a booking
export const mockUpdateBooking = async (id, updatedBooking) => {
  await new Promise(resolve => setTimeout(resolve, 300));
  const stored = JSON.parse(localStorage.getItem('mockBookings') || '[]');
  const index = stored.findIndex(b => b.id === id);
  if (index === -1) {
    throw new Error('Booking not found');
  }
  stored[index] = { ...stored[index], ...updatedBooking };
  localStorage.setItem('mockBookings', JSON.stringify(stored));

  // Uppdatera också storedBookings arrayen så att ändringarna syns i applikationen
  storedBookings.length = 0;
  storedBookings.push(...stored);

  return { success: true };
};

// Mock function for deleting a booking
export const mockDeleteBooking = async (id) => {
  await new Promise(resolve => setTimeout(resolve, 300));
  const stored = JSON.parse(localStorage.getItem('mockBookings') || '[]');
  const filtered = stored.filter(b => b.id !== id);
  localStorage.setItem('mockBookings', JSON.stringify(filtered));

  // Uppdatera också storedBookings arrayen så att ändringarna syns i applikationen
  storedBookings.length = 0;
  storedBookings.push(...filtered);

  return { success: true };
};

// Mock function for bulk deleting bookings in a date range
export const mockDeleteBookingsRange = async (start, end) => {
  await new Promise(resolve => setTimeout(resolve, 300));
  const stored = JSON.parse(localStorage.getItem('mockBookings') || '[]');
  const filtered = stored.filter(b => !(b.date >= start && b.date <= end));
  localStorage.setItem('mockBookings', JSON.stringify(filtered));

  // Uppdatera också storedBookings arrayen så att ändringarna syns i applikationen
  storedBookings.length = 0;
  storedBookings.push(...filtered);

  return { success: true, deleted: stored.length - filtered.length };
};
